import React, {useEffect, useState} from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import AnimatedNumber from "animated-number-react";
import {LogService} from "../../../services/LogService";
import { DefectService } from "../../../services/DefectService";

const Treefells = () => {
  return (
    <div className="w-full h-full  flex flex-col items-start">
      <TreeFellsHeader />
      <Outlet />
    </div>
  );
};

export default Treefells;

const TreeFellsHeader = () => {
  const { pathname } = useLocation();
  const onAll = pathname === "/dashboard/tree-fell/all";

  const [state, setState] = useState({
    totalCount:0,
  totalDelivered:0,
  totalFresh: 0,
  totalInSlidingArea: 0,
  totalTransported: 0,

  });


  const loadStockTotals = () => {
    LogService.GetLogStats().then((res) => {
      // console.log(res)

      setState({
        ...state,
        totalCount: res.totalCount,
        totalDelivered: res.totalDelivered,
        totalFresh: res.totalFresh,
        totalInSlidingArea: res.totalInSlidingArea,
        totalTransported: res.totalTransported,

      });
    });
  };

  const [defectCount, setDefectCount] = useState(0);

  useEffect(() => {
    loadStockTotals();
    DefectService.GetAllDefects().then((res) => setDefectCount(res ? res.length : 0));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {onAll ? (
        <div className="w-full">
          <div className="w-full  flex justify-between items-center">
            <h1 className="text-4xl font-extrabold my-3 text-slate-700">
              Log Management
            </h1>
          </div>
          <div className="w-full grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            <LabelAndValue
              label={"Fresh"}
              value={state.totalFresh}
              className="text-gray-500/75"
            />
            <LabelAndValue
              label={"Moved to Siding Area"}
              value={state.totalInSlidingArea}
              className="text-gray-500/75"
              active
            />
            <LabelAndValue
              label={"Transported"}
              value={state.totalTransported}
              className="text-blue-500/75"
            />
            <LabelAndValue
              label={"Delivered"}
              value={state.totalDelivered}
              className="text-green-500/75"
            />
            <Link
              to="/dashboard/tree-fell/defects"
              className="bg-white shadow-sm min-h-[5vh] rounded-lg p-6 flex flex-col justify-between space-y-4 hover:shadow-md transition ease-in-out delay-150"
            >
              <span className="text-lg font-medium text-gray-300 uppercase">
                Defects
              </span>
              <AnimatedNumber
                value={defectCount}
                className="text-5xl font-bold text-amber-500/75"
                formatValue={(value) => value.toFixed(0)}
                duration={2000}
              />
            </Link>
          </div>
        </div>
      ) : null}
    </>
  );
};

export const LabelAndValue = (props) => {
  const { label, value, className } = props;
  const formatValue = (value) => value.toFixed(0);
  return (
    <div
      className={`bg-white shadow-sm min-h-[5vh] rounded rounded-lg p-6 flex flex-col justify-between space-y-4 hover:shadow-md transition ease-in-out delay-150 `}
    >
      <span className="text-lg font-medium text-gray-300 uppercase">
        {label}
      </span>
      <AnimatedNumber
        value={value}
        className={`text-5xl font-bold  ${className}`}
        formatValue={formatValue}
        duration={2000}
      />
    </div>
  );
};
